const env = (import.meta as ImportMeta & { env?: Record<string, string> }).env ?? {};

export default {
  // Jupiter API key (get free key from portal.jup.ag - 60 req/min free tier)
  // Set via VITE_JUPITER_API_KEY env var or override in environment-specific config
  JUPITER_API_KEY: env.VITE_JUPITER_API_KEY || '',

  // Jupiter API version: 'ultra' (default, faster) or 'legacy' (2-step quote→swap)
  // Override in environment-specific config files (development.ts, staging.ts, production.ts)
  JUPITER_API_VERSION: 'ultra' as 'ultra' | 'legacy',

  WALLET_CONNECT_PROJECT_ID: 'd9fd02157f787715c4f9eb7f1e97f92f',
  WALLET_CONNECT_METADATA: {
    name: 'Junk.Fun',
    description: 'Junk.Fun - Burn tokens, win prizes',
    url: 'https://www.junk.fun',
    icons: ['https://www.junk.fun/logo.png'],
  },
  IPDATA_APIKEY: '06704576fedf50682a9707b5e01c528ec965da1e6f8416bf98098f14',
  CLOUDFLARE_SITEKEY: '0x4AAAAAACAbYa5muTmlFZKP', // Turnstile site key for email verification

  // Phantom SDK Configuration
  PHANTOM_APP_ID: 'a63038fb-f6a1-4abd-a6a9-83bbca27e934',
  PHANTOM_WALLET_ID: '3a85c44f-5e33-4588-87f8-b3e19ae96eb4', // Phantom wallet ID from WalletConnect/Reown registry
  ENABLE_PHANTOM_EMBEDDED_WALLET: false,
  ENABLE_PNFT_JUNKING: false,
  SHOW_ASSET_DISCOVERY_DEBUG: false,
};
